<script lang="ts">
	export let i: string | string[];
</script>

{#if i instanceof Array}
	<i class={'fas ' + i.map( k => 'fa-' + k ).join( ' ' )} />
{:else}
	<i class="fas fa-{ i }" />
{/if}
